import styled from 'styled-components';

export const StarRatingNumberOnlyStyled = styled.div`
  padding: 3px 0 3px 3px;
  background: ${(props) => props?.theme?.color?.white};
  margin-left: auto;
  display: flex;
  flex-direction: row;
  align-items: center;

  .ic {
    min-width: 14px;
    margin-right: 5px;
    display: flex;
  }

  .rating {
    font-size: 15px;
    line-height: 18px;
    font-weight: 600;
  }

  &.onPDP {
    padding: 0px 6px;
    border: 1px solid ${(props) => props?.theme?.color?.divider};
    border-radius: 7px;

    .ic {
    }

    .rating {
      font-size: 12px;
      line-height: 23px;
      font-weight: 600;
    }
  }

  &.onRatingBig {
    .ic {
      min-width: 20px;
    }

    .rating {
      font-weight: 600;
      font-size: 28px;
      line-height: 36px;
    }
  }

  &.onRatingSmall {
    &.grey {
      .ic {
        filter: brightness(0%) invert(77%) sepia(16%) saturate(188%) hue-rotate(155deg) brightness(98%) contrast(84%);
      }
    }
    .rating {
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
    }
  }
  @media (max-width: 390px) {
    margin-left: ${(props) => (props.isProductCard ? '0px !important' : '149px')};
  }

  @media (max-width: 430px) {
    margin-top: ${(props) => (props.isProductCard ? '136px' : '0px')};
    margin-left: ${(props) => (props.isProductCard ? '0px' : '149px')};
  }
  @media (max-width: 360px) {
    margin-left: ${(props) => (props.isProductCard ? '0px !important' : '149px')};
  }
`;
